const key = Symbol('ThemeKey');

export default key;
